import {GET_PERSONAL} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  detail: '',
};

export const getPersonalReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERSONAL:
      return {
        ...state,
        detail: action.payload.detail,
      };
    default:
      return state;
  }
};

export default getPersonalReducers;
